import { Button, Checkbox, Col, Form, Row } from "antd";
import React from "react";
import { useRef } from "react";
import { useState, useEffect } from "react";
import { useAuth } from "../../context/auth";
import { useHistory } from "react-router-dom";

const LandingPage = () => {
  const history = useHistory();
  const listInnerRef = useRef();

  const { acceptTerm, getHome } = useAuth();

  const [form] = Form.useForm();
  const [show, setShow] = useState(false);
  const [tc, setTc] = useState(false);
  const [pp, setPp] = useState(false);

  const [data, setData] = useState({
    term: "",
    policy: "",
  });

  const getTermConditionPolicyDetail = async () => {
    const { terms } = await fetch(new URL('/api/terms', window.location)).then(res => res.json());
    const { privacy } = await fetch(new URL('/api/privacy', window.location)).then(res => res.json());

    setData({ term: terms.detailTh, policy: privacy.detailTh });
  };

  useEffect(() => {
    getTermConditionPolicyDetail();
  }, []);

  const onAccept = () => {
    acceptTerm();
    history.push(getHome());
  };

  const onScroll = () => {
    if (listInnerRef.current) {
      const { scrollHeight } = listInnerRef.current;
      let bottomHeight = scrollHeight - 200;
      if (bottomHeight <= scrollHeight) setShow(true);
    }
  };

  useEffect(() => {
    onScroll();
  }, []);

  return (
    <>
      <Row>
        <Col span={14} offset={5}>
          <div>
            <h1 className="text-4xl text-center mt-5">
              Term&Condition and Privacy Policy
            </h1>
            <div
              id="terms"
              onScroll={onScroll}
              ref={listInnerRef}
              style={{ height: "700px", overflowY: "auto" }}
              className="mt-5"
              dangerouslySetInnerHTML={{ __html: data.term + data.policy }}
            />

            <Form form={form} layout="vertical" onFinish={onAccept}>
              {show && (
                <>
                  <Form.Item className="mt-4 mb-1 px-4" colon={false} name="tc" valuePropName="checked">
                    <Checkbox onChange={(e) => setTc(e.target.checked)}                    >
                      I agree with Term&Condition
                    </Checkbox>
                  </Form.Item>
                  <Form.Item colon={false} className="px-4" name="pp" valuePropName="checked">
                    <Checkbox onChange={(e) => setPp(e.target.checked)}                    >
                      I agree with Privacy Policy
                    </Checkbox>
                  </Form.Item>
                </>
              )}
              <Form.Item
                style={{ width: "100%" }}
                colon={false}
                name="btn-accept"
              >
                <div className="flex justify-center">
                  <Button
                    disabled={tc === true && pp === true ? false : true}
                    className="w-48 h-10 my-4"
                    htmlType="submit"
                    type="primary"
                    shape="round"
                  >
                    Accept
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default LandingPage;
